import ButtonFactory from './utils/ButtonFactory';

export default {
	/**
	 * @static
	 * @type {number}
	 */
	zoom: window.outerWidth / window.innerWidth,

	/**
     * @static
     * @type {number}
     * @default 1664
     */
	STAGE_WIDTH: 1664,

	/**
     * @static
     * @type {number}
     * @default 768
     */
	STAGE_HEIGHT: 768, // (window.outerWidth / window.innerWidth),

	/**
     * @static
     * @type {object}
     */
	config: {},

	/**
     * @static
     * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
     */
	renderer: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	stage: null,

	/**
     * @static
     * @type {P3.Ticker}
     */
	ticker: null,

	/**
     * @static
     * @type {PIXI.Container}
     */
	transitions: null,

	/**
     * @static
     * @type {IsoWorld}
     */
	world: null,

	/**
     * @type {Boolean}
     */
	started: false,

	/**
     * @type {String}
     */
	advisor: null,

	/**
     * @static
     * @type {String}
     */
	difficulty: 'easy',

	/**
     * @static
     * @type {Scenario}
     */
	scenario: null,

	/**
     * @type: {AchievementManager}
     */
	achievements: null,

	/**
     * @static
     * @type {String}
     */
	selectedLevel: '',

	/**
	 * @static
	 * @type {String}
	 */
	levelToUnload: null,

	/**
	 * @static
	 * @type {P3.TrackingModuleGtag}
	 */
	tracking: null,

	/**
	 * @static
	 * @type {String}
	 */
	loadedLevel: '',

	/**
	 * static
	 * @type {Boolean}
	 */
	debug: false,

	/**
     * @static
     * @type {Number}
     */
	selectedScenario: 1,

	/**
     * @static
     * @type {Object}
     */
	lastBuild: { id: 0, cost: 0, devcost: 0, special: '' },

	/**
     * @type {Number}
     */
	score: 0,

	/**
     * Hex colour values for each of the Risk categories.
     * @static
     * @type {number[]}
     */
	riskColours: [
		0x9AD528, 	// Risk 1
		0xF7D503, 	// Risk 2
		0xFF8400, 	// Risk 3
		0xFF1900, 	// Risk 4
		0xBE22D4, 	// Risk 5
	],

	// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
	/**
     * @type {Function}
     * @param x {Number}
     * @returns {string}
     */
	numberWithCommas: (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),

	buttonFactory: new ButtonFactory(),

	paused: false,
	popupOpen: false,

	onLanguageChanged: null,
	languageManager: null,
	fonts: [],

	// threejs
	tRenderer: null,
	tScene: null,
	tCamera: null,
	AssetManager: null,

	// settings
	motion: true,
	motionToggle: new P3.utils.MiniSignal(),
	retina: '1x',
};
